import { html } from "lit-html"
import { virtual } from "haunted"

import { TagList } from "./components/header"
import { DateTimeInfo } from "./components"
import { ROLE_ICON_MAP } from "../constants"
import markdown from "../utils/markdown"

const NOTES = "Notes"
const TWEETING = "Live-tweeting"
const GOOGLE_DRIVE = "Google Drive"
const TWITTER = "Twitter thread"
const BLUESKY = "Bluesky thread"

const RoleDocLinks = ({
  roles,
  url: assignmentUrl,
  summary: assignmentSummary,
}) => {
  const mainCategoryDocMap = {
    [NOTES]: [GOOGLE_DRIVE],
    [TWEETING]: [TWITTER, BLUESKY],
  }
  let roleDict = {}

  roles.forEach(({ category, label, user, summary, documents }) => {
    const reportingCategories = mainCategoryDocMap[category] || []
    const catDocs = documents.filter((doc) =>
      reportingCategories.includes(doc.category)
    )
    if (roleDict[category] || catDocs.length == 0) {
      const oldSummary = roleDict[category]?.summary || ``
      roleDict[category] = {
        category,
        label,
        user,
        url: assignmentUrl,
        summary: summary.length > oldSummary.length ? summary : oldSummary,
      }
    } else {
      roleDict[category] = {
        category,
        label,
        user,
        url: catDocs[0].reporting_url,
        summary,
      }
    }
  })
  const roleData = Object.values(roleDict).sort((a, b) => {
    // Map category of roles to value: 1 for Notes, 0 for Live-tweeting, -1 for other categories
    const mainCategories = [TWEETING, NOTES]
    const aIndex = mainCategories.indexOf(a.category)
    const bIndex = mainCategories.indexOf(b.category)
    return bIndex - aIndex || a.category.localeCompare(b.category)
  })
  const teaser = (
    roleData.reduce(
      (currentTeaser, role) => currentTeaser || role.summary,
      ``
    ) || assignmentSummary
  ).replace(/[\n\r]/g, ` `)

  return html`
    <div class="border-l-4 border-yellow pl-8">
      <div class="flex flex-wrap">
        ${roleData.map(
          ({ category, user, url, label }) =>
            html`<div class="mb-4 flex mr-9">
              <a
                class="role-icon-link mr-4 h-10 w-10 rounded-lg ${category}"
                href=${url}
                target="${url.startsWith("/") ? "" : "_blank"}"
                aria-label="${label}"
              >
                <i
                  class=${category in ROLE_ICON_MAP
                    ? ROLE_ICON_MAP[category]
                    : "fas fa-pen-alt"}
                >
                </i>
                <span aria-hidden="true" class="icon-tooltip">${label}</span>
              </a>
              <div class="text-gray-interactive">
                <span class="block text-tiny">${label} by</span>
                <span class="block text-sm font-bold">${user || "-"}</span>
              </div>
            </div>`
        )}
      </div>
      <div class="clamp-lines-3">${teaser ? markdown(teaser) : ``}</div>
    </div>
  `
}

const ReportingRow = virtual(
  ({
    name,
    url,
    summary,
    agency,
    start_date,
    start_time,
    end_time,
    shortened_timezone,
    tags,
    roles,
  }) => {
    const primaryTags = tags
      .filter((tag) => !("primary" in tag) || tag.primary)
      .map((tag) => tag.name)

    return html`
      <div
        class="reporting group filter-result-card cursor-pointer"
        role="button"
        @click=${() => {
          window.location.href = url
        }}
      >
        ${TagList(primaryTags, "mb-5")}
        <p
          class="title mb-5 text-lg text-blue group-hover:text-black font-bold"
        >
          ${name}
        </p>
        <div class="mb-6 flex flex-wrap leading-loose">
          ${DateTimeInfo({
            date: start_date,
            start_time,
            end_time,
            shortened_timezone,
            agency,
          })}
        </div>
        ${RoleDocLinks({ roles, url, summary })}
      </div>
    `
  }
)

export default ReportingRow
